import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import Loader from "../../shared/loader";
import Pagination from "../../shared/pagination";

const PurchaseOrder = () => {
  const [purchaseOrder, setPurchaseOrder] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 30;

    const getPurchaseOrder = (page = 1) => {
    setLoading(true);
    axios.post(API_URL.PURCHASE_ORDER_LIST, {
      page: page,
      limit: itemsPerPage,
    }).then(
      (res) => {
          if (res.data.status === 1) {
            res.data.data.data.map(item => item.date = moment(item.date).format('DD/MM/YYYY'));
            setPurchaseOrder(res.data.data.data);
            const total = res.data.data.total || 0;
            setTotalPages(Math.ceil(total / itemsPerPage));
            setTotalCount(total);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

 const deletePurchaseOrder = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Purchase Order",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PURCHASE_ORDER_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              toast.success("Delete Successfully", { autoClose: 3000 });
              getPurchaseOrder(currentPage);
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getPurchaseOrder(currentPage);
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getPurchaseOrder(page);
  };
  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Purchase Order <small className="me-2">({totalCount})</small>
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/purchase-order/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
              Add Purchase Order
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>#</th>
                        <th>Purchase Order No.</th>
                        <th>Date.</th>
                        <th>Party Name</th>
                        <th>Total Qty</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {purchaseOrder?.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{(currentPage - 1) * itemsPerPage + key + 1}</td>
                            <td>
                              {row.prefix}/{row.purchase_order_number}
                            </td>
                            <td>
                              {row.date}
                            </td>
                            <td>
                              {row.supplier.name}
                            </td>
                            <td>
                                {row.total_qty}
                            </td>
                            <td>
                              <Link
                                to={"/purchase-order/view/" + row.id}
                                className="btn btn-sm btn-dark mr-2"
                              >
                                <i className="fa fa-eye me-1"></i> View
                              </Link>
                              <Link
                                to={"/purchase-order/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deletePurchaseOrder(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center my-3">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseOrder;
